import { Menu } from "@headlessui/react";
import { Fragment, type ReactNode } from "react";

import type { ItemLinkTo } from "./ItemLink";
import { ItemLink } from "./ItemLink";

export interface ItemWithLinkProps {
  [key: string]: any;
  active?: boolean;
  children: ReactNode;
  hasDanger?: boolean;
  linkType?: "button" | "submit" | "reset";
  onClick?: (event: any) => void;
  role?: string;
  to?: ItemLinkTo;
}

export const ItemWithLink = ({
  children,
  active: isActiveProp,
  onClick,
  to,
  ...rest
}: ItemWithLinkProps) => (
  <Menu.Item as={Fragment}>
    {({ active }) => (
      <ItemLink
        to={to}
        onClick={onClick}
        active={active || isActiveProp}
        {...rest}
      >
        {children}
      </ItemLink>
    )}
  </Menu.Item>
);
